export const app_cookie = Object.freeze({
  todays_key: 'fffm_key',
  listened_guide: 'fffm_listened_guide',
  listened_quiz: 'fffm_listened_quiz',
  is_shown_opening: 'fffm_shown_opening',
  lang: 'fffm_lang',
  os: 'fffm_os',
})
